<template>
  <div id="workbench">
    <div class="ipub-p1 mar-b-30">
      <span style="margin-right:12px"
            class="line-h-40">Journal</span>
      <ipub-select v-model="params.journalId"
                   style="width:220px"
                   placeholder="All Journals"
                   @change="changejournal"
                   :options="journalList" />
    </div>
    <manuscript-task :journalId="params.journalId"></manuscript-task>
    <div class="flex row2-content">
      <div class="artical-ranking-div">
        <artical-ranking :journalId="params.journalId"></artical-ranking>
      </div>
      <div class="artical-echart">
        <div class="artical-echart-title mar-b-20">
          <div class="flex mar-b-20 artical-echart-title-title">
            <div class="title-tab">
              <span :class="['ipub-h1','ipub-cursor-pointer','title-tab-title',articalStatu===item?'title-tab-title-active':'']"
                    v-for="(item,index) in articalTab"
                    :key="item+index"
                    @click="changeArtical(item)">{{index}}</span>
            </div>
          </div>
          <div class="ipubw-p1 relative ">
            <ipub-select v-model="titleStatu"
                         style="width:150px"
                         @change="changeArticalTime">
              <ipub-select-option :value="item.statu"
                                  v-for="item in titleTab"
                                  :key="item.title">
                {{item.title}}
              </ipub-select-option>
            </ipub-select>
            <ipub-button type="primary"
                         size="small"
                         class="right-option"
                         style="width:80px"
                         @click="exportExl">
              Export
            </ipub-button>
          </div>
        </div>
        <div class="artical-echart-content">
          <analysis-chart :artical="articalStatu"
                          :journalId="params.journalId"
                          :startDate="params.accessDateStart"
                          :endDate="params.accessDateEnd" />
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main.js'
export default main
// 业务处理
</script>
